import React, { useState, useEffect } from "react";
import "./Bottomnav.css";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import { Link } from "react-router-dom";
import { auth } from "../service/firebase";

function Bottomnav() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-around bottomNav">
      <Link to="/menu">
        <PeopleAltIcon
          style={{ color: "white", fontSize: "35", cursor: "pointer" }}
        />
      </Link>
      <Link to="/">
        <HomeOutlinedIcon
          style={{ color: "white", fontSize: "35", cursor: "pointer" }}
        />
      </Link>
      <div data-toggle="modal" data-target="#addPostModal">
        <AddOutlinedIcon
          style={{ color: "white", fontSize: "35", cursor: "pointer" }}
        />
      </div>
      {user ? (
        <Link to="/userprofile">
          <PersonOutlineOutlinedIcon
            style={{ color: "white", fontSize: "35", cursor: "pointer" }}
          />
        </Link>
      ) : (
        "Login/SignUp"
      )}
    </div>
  );
}

export default Bottomnav;
